<template>
	<div class="hero-subpage js-hero-subpage-area" v-bind:class="{ 'is-revealed': active }">
	    <div class="container">	           
	    	<h2>Produkty<br />
				i&nbsp;<span>usługi</span></h2>
			<p><router-link class="btn btn-hero" to="/co-mozemy-dla-ciebie-zrobic" title="Produkty software'owe">Zobacz ofertę</router-link></p>
	        </div>
	    </div>
</template>
<script>
export default {
  name: 'Subpage',
  data: function () {
    return {
      active: false
    }
  },
	mounted() {
		setTimeout(function(){
            this.active=true;
        }.bind(this), 100);	
	}
}
</script>